<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="error d-flex flex-row-fluid bgi-size-cover bgi-position-center"
      style="background-image: url(/media/error/404.jpg)"
    >
      <div
        class="px-10 px-md-30 py-10 py-md-0 d-flex flex-column justify-content-md-center"
      >
        <h1 class="error-title text-stroke text-transparent">403</h1>

        <p class="display-4 font-weight-boldest text-white mb-5">
          Permission Denied
        </p>
        <p class="font-size-h4 font-weight-bolder text-dark-75">
          You don't have the required permission to access this page.
        </p>
        <router-link to="/">
          <p class="font-size-h4 font-weight-bolder text-dark-75">
            Go back to home
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "403-Forbidden",
};
</script>

<style lang="scss">
@import "~@/assets/sass/pages/error.scss";
</style>
